import React, { Component } from "react"

// Last line of defense: any uncaught render/lifecycle error below this
// boundary shows a themed fault screen instead of unmounting the whole
// app to a white page. Deliberately renders plain DOM (no Arwes, no
// styled-components) so the fallback itself can't throw.
class ErrorBoundary extends Component {
  state = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    console.error(
      "%c UI crash caught by ErrorBoundary",
      "background: red; color: yellow",
      error,
      info
    )
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children
    }
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "#030021",
          color: "#ff001c",
          fontFamily: "'VT323', monospace",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 20,
          textAlign: "center",
          padding: 24
        }}
      >
        <div style={{ fontSize: "1.6rem", letterSpacing: "0.12em" }}>
          SYSTEM FAULT // the interface hit an unexpected error
        </div>
        <div style={{ color: "#6fbfff" }}>
          Your data is safe — reloading usually clears it.
        </div>
        <button
          onClick={this.handleReload}
          style={{
            background: "transparent",
            border: "1px solid #17ff0e",
            color: "#17ff0e",
            fontFamily: "inherit",
            fontSize: "1.1rem",
            letterSpacing: "0.1em",
            padding: "10px 26px",
            cursor: "pointer"
          }}
        >
          RELOAD INTERFACE
        </button>
      </div>
    )
  }
}

export default ErrorBoundary
